import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import DragAndDropList from 'core/dragAndDropList';
import { Drag } from 'ui/icons/action/Drag';
import { Button } from '@iterable/deprecated_react_components';
import SegmentConnector from '../segmentConnector';

export const StyledCoreButton = styled(Button)`
  position: relative;
  left: ${pxToRem(52)}; /** queryBuilderCriteriaPropertyLabelWidth + spacing half */
`;

export const PropertyGroupsContainer = styled.div<{ hideProperty: boolean }>`
  padding: ${pxToRem(10)};
  padding-top: ${({ hideProperty }) => (hideProperty ? '0' : 'inherit')};
`;

export const StyledDrag = styled(Drag)`
  display: block;
  opacity: 0.6;
  transition: opacity 0.2s;
  margin-left: ${pxToRem(5)};
`;

export const StyledSegmentConnector = styled(SegmentConnector)<{ isViewMode: boolean }>`
  > div:after {
    opacity: 1;
    transition: opacity 0.2s;
  }
  > [data-role='label'] {
    border-top-right-radius: ${({ isViewMode }) =>
      isViewMode ? '0' : 'inherit'}; /** css file conversion */
    border-bottom-right-radius: ${({ isViewMode }) =>
      isViewMode ? '0' : 'inherit'}; /** css file conversion */
  }
`;

export const CriteriaContainer = styled.div<{
  isViewMode: boolean;
  isViewModeWithProperty: boolean;
  queryCombinator: string;
}>`
  align-items: baseline;
  background: ${({ isViewMode }) => (isViewMode ? '#fff' : '#eff0f0')}; /** css file conversion */
  border-radius: ${pxToRem(3)};
  border-bottom-left-radius: ${({ isViewMode }) => (isViewMode ? '0' : 'inherit')};
  border-top-left-radius: ${({ isViewMode }) => (isViewMode ? '0' : 'inherit')};
  border: ${({ isViewMode }) => (isViewMode ? '1px solid' : '0px solid')};
  border-color: ${({ queryCombinator }) => {
    switch (queryCombinator) {
      case 'Not':
        return '#d96458';
      case 'And':
        return '#52ce86';
      case 'Or':
        return '#54a2d7';
      default:
        return '#000';
    }
  }};
  display: ${({ isViewModeWithProperty }) => (isViewModeWithProperty ? 'flex' : 'unset')};
  flex: ${({ isViewMode }) => (isViewMode ? '0 1 auto' : '1 1 auto')};
  margin: ${({ isViewMode }) =>
    isViewMode ? `0 0 0 -${pxToRem(1)}` : `0 0 ${pxToRem(10)} ${pxToRem(10)}`};
  transition: box-shadow 0.2s;
`;

export const PropertyContainer = styled.div<{ hideProperty: boolean; isViewMode: boolean }>`
  align-items: center;
  display: ${({ hideProperty, isViewMode }) => (hideProperty && isViewMode ? 'none' : 'flex')};
  height: ${pxToRem(48)}; /** maybe 0 */
  padding: 0 ${pxToRem(10)} 0 0;
  justify-content: space-between;
`;

export const StyledCoreDraggable = styled(DragAndDropList.Draggable)<{ isViewMode: boolean }>`
  &&&& {
    display: flex;
    height: 100%;
    width: 100%;
    background: none;
    margin: 0 0 ${({ isViewMode }) => (isViewMode ? `${pxToRem(5)}` : '0')}; /** css file conversion */
    padding: 0;
    transition: height 0s, transform 0s, opacity 0s;
    &:hover,
    &:active {
      ${StyledDrag} {
        opacity: 0.8;
      }
      .cssActionButtons {
        opacity: 1;
      }
    }
    &.cssDraggingClass {
      ${StyledSegmentConnector} {
        > div:before,
        > div:after {
          opacity: 0;
        }
      }
      ${CriteriaContainer} {
        box-shadow: 0 0 ${pxToRem(8)} rgba(0, 0, 0, 0.4); /** css file conversion */
      }
    }
    .cssActionButtons {
      opacity: 1;
      transition: opacity 0.2s;
    }
  }
`;
